import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterElectricChargingTimeStandardModeSearchValueObject extends ValueObject {
  #chargingTimeStandardMode

  constructor({chargingTimeStandardMode}) {
    super()
    this.#chargingTimeStandardMode = chargingTimeStandardMode
  }

  static create({chargingTimeStandardMode}) {
    return new FilterElectricChargingTimeStandardModeSearchValueObject({
      chargingTimeStandardMode: FilterRangeSearchValueObject.create(chargingTimeStandardMode)
    })
  }

  static createWithDefaultValue({config, chargingTimeStandardMode}) {
    const {DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH} = config.get('searchFilters')

    return new FilterElectricChargingTimeStandardModeSearchValueObject({
      chargingTimeStandardMode: FilterRangeSearchValueObject.create({
        from: chargingTimeStandardMode?.from || DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH.from,
        to: chargingTimeStandardMode?.to || DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH.to
      })
    })
  }

  static createQueryParams({config, chargingTimeStandardMode}) {
    const {DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} =
      config.get('searchFilters')

    return new FilterElectricChargingTimeStandardModeSearchValueObject({
      chargingTimeStandardMode: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].from,
          value: chargingTimeStandardMode?.from || DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].to,
          value: chargingTimeStandardMode?.to || DEFAULT_ELECTRIC_CHARGING_TIME_STANDARD_MODE_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#chargingTimeStandardMode.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#chargingTimeStandardMode.from.isEmpty && {
        ...this.#chargingTimeStandardMode.from.queryParam
      }),
      ...(!this.#chargingTimeStandardMode.to.isEmpty && {
        ...this.#chargingTimeStandardMode.to.queryParam
      })
    }
  }

  get value() {
    return this.#chargingTimeStandardMode.value
  }

  toJSON() {
    return {
      chargingTimeStandardMode: this.#chargingTimeStandardMode.toJSON()
    }
  }
}
